import { DISCLAIMER, PRIVACY_NOTE } from '../wording';

export function Disclaimer() {
  return (
    <p class="disclaimer">
      <strong>{DISCLAIMER.lead}</strong> {DISCLAIMER.body}
    </p>
  );
}

export function PrivacyNote() {
  return (
    <div class="privacy">
      <p>
        <strong>{PRIVACY_NOTE.lead}</strong> {PRIVACY_NOTE.body}
      </p>
      <details>
        <summary>{PRIVACY_NOTE.detailsTitle}</summary>
        <p>{PRIVACY_NOTE.details}</p>
      </details>
    </div>
  );
}
